module.exports = __webpack_public_path__ + "static/media/login.e74bde6e.png";